<template>
  <div>
    <div>
      <div class="contain">
        <div v-if="id==0" v-html="lists[0]"></div>
        <div v-if="id==1" v-html="lists[1]"></div>
        <div v-if="id==2" v-html="lists[2]"></div>
        <div v-if="id==3" v-html="lists[3]"></div>
        <div v-if="id==4" v-html="lists[4]"></div>
        <div v-if="id==5" v-html="lists[5]"></div>
      </div>
    </div>
  </div>
</template>
<script>
import icon from '../components/tpl1/icon'
import ico1 from '../imgs/ico1.png'
import ico2 from '../imgs/ico2.png'
import ico3 from '../imgs/ico3.png'
import ico4 from '../imgs/ico4.png'
import ico5 from '../imgs/ico5.png'
import ico6 from '../imgs/ico6.png'
import ico7 from '../imgs/ico7.png'
export default {
    data() {
            return {
                id: 0,
                exitActive: false, //用户退出状态，false为未登录 true为登录
                flag: false, //是否打开登录框
                activeTab: 0,
              navs: [
//            `Home  News  Organization  Guide   Agenda   Submission   Registration`,
                {
                  iconClass: 'fa-home',
                  imageSrc: ico1,
                  text: 'Home',
                  child: []
                },
                {
                  iconClass: 'fa-newspaper-o',
                  imageSrc: ico2,
                  text: 'Congress Information',
                  child: [
                    {
                      text: 'Introduction',
                      href: '',
                      route: false
                    }, {
                      text: 'Welcome Letter',
                      href: '',
                      route: true
                    }, {
                      text: 'General Information',
                      href: '',
                      route: false
                    }, {
                      text: 'Organization',
                      href: '',
                      route: false
                    }, {
                      text: 'About IMS',
                      href: ' http://www.meningiomasociety.org',
                      route: false
                    }, {
                      text: 'About Beijing Tiantan Hospital',
                      href: ' http://www.bjtth.org/Html/News/Articles/3724.html',
                      route: false
                    }
                  ]
                },
                {
                  iconClass: 'fa-sitemap',
                  imageSrc: ico3,
                  text: 'Scientific Information',
                  child: [
                    {
                      text: 'Pre-Congress Courses',
                      href: '',
                      route: false
                    }, {
                      text: 'Program at a glance',
                      href: '',
                      route: false
                    }, {
                      text: 'Introduction of the masters',
                      href: '',
                      route: false
                    }, {
                      text: 'Abstract Submission',
                      href: '',
                      route: false
                    }, {
                      text: 'Instruction & Guideline for Speakers',
                      href: '',
                      route: false
                    }, {
                      text: 'About Beijing Tiantan Hospital',
                      href: '',
                      route: false
                    }, {
                      text: 'Important Dates',
                      href: '',
                      route: false
                    }
                  ]
                },
                {
                  iconClass: 'fa-superpowers',
                  imageSrc: ico4,
                  text: 'Social Program',
                  child: [
                    {
                      text: 'Welcome Reception',
                      href: '',
                      route: false
                    }, {
                      text: 'Gala Dinner',
                      href: '',
                      route: false
                    }, {
                      text: 'Visit New Beijing Tiantan Hopital',
                      href: '',
                      route: false
                    }, {
                      text: 'Travel Agent',
                      href: '',
                      route: false
                    }
                  ]
                },
                {
                  iconClass: 'fa-book',
                  imageSrc: ico5,
                  text: 'Registration  &  Accommodation',
                  child: [
                    {
                      text: 'Registration',
                      href: '',
                      route: false
                    }, {
                      text: 'Accommodation',
                      href: '',
                      route: false
                    }
                  ]
//            href:'/home_detail/5'
                },
                {
                  iconClass: 'fa-file-word-o',
                  imageSrc: ico6,
                  text: 'Sponsorship  &  Exhibitions',
                  child: [
                    {
                      text: 'Information for Sponsors and Exhibitors',
                      href: '',
                      route: false
                    }, {
                      text: 'Sponsors',
                      href: '',
                      route: false
                    }, {
                      text: 'Exhibitors',
                      href: '',
                      route: false
                    }
                  ]
                },
                {
                  iconClass: 'fa-pencil-square-o',
                  imageSrc: ico7,
                  text: 'Useful Links',
//            reg: true,
                  child: [
                    {
                      text: 'IMA',
                      href: '',
                      route: false
                    }, {
                      text: 'Beijing Tiantan Hospital',
                      href: ' http://www.bjtth.org/Html/News/Main/1125.html',
                      route: false
                    }, {
                      text: 'China National Convention Center',
                      href: ' http://www.cnccchina.com/en/default.aspx',
                      route: false
                    }
                  ]
                }
              ],
                lists: [
                    `
                    <div class="article_con">
           <h1 class="title3" style="text-align: center;"> <font color="">Beijing Tiantan International Forum of Neurosurgery(BIFNS)</font></h1>
           <div style="display:none">浏览次数：

          <span id="ajax_div__GetArticleViewCount_0_5795_0_9372">
          232</span></div>
           <div class="article_cont" id="zoom">
           <p><img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344268790248724834600.jpg" style="float:right;" title="神外LOGO.jpg"></p><p><img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344268497731994066374.jpg" style="float:right;" title="天坛医院LOGO.jpg"></p><p><span style="font-size: 14px;">Dear Colleagues and Friends,</span></p><p><span style="font-size: 14px;">It gives us great pleasure and privilege to warmly invite you for the 1st
          Beijing Tiantan International Forum of Neurosurgery(BIFNS) in Beijing,
          People’s</span></p><p><span style="font-size: 14px;">Republic of China in November 2017. This forum marks and celebrates the
          official opening of our newly founded Beijing Tiantan Hospital, which is
          deliberately organized and fully supported by the standing committee and every
          staff. Taking this opportunity, 10th International Meningioma Society &amp;
          Cerebral Venous System Meeting will also be held together.</span></p><p><span style="font-size: 14px;">Beijing TianTan Hospital was firstly founded on August 23, 1952 and later
          expanded by our beloved Dr. Wang Zhongcheng to develop the practice of
          neurosurgery in China. Thanks to Dr. Wang and numerous pioneering colleagues, Department of Neurosurgery of Beijing TianTan
          Hospital has been No.1 ranking in neurosurgery in China for years. The annul
          number of neurosurgical operations is over 10,000 for the last five years, in
          particularly many of which were difficult and complex. Supported by both state
          and local government, New Beijing Tiantan Hospital was proposed and started
          construction in HuaXiang (“County of flower”) south of Beijing, seating 1500
          inpatient beds equipped with advanced facilities. The opening of our new
          hospital will be in Fall of 2017, providing a better healthcare care service and
          research.</span></p><p><span style="font-size: 14px;">To celebrate this historical moment, 1st Beijing Tiantan International
          Forum of Neurosurgery is scheduled to be held from November 2-5, 2017. A variety
          of neurosurgical topics, reports and academic activities will be covered
          including surgical operational experience, cutting-edge research, hands on
          workshop, keynote lectures, inter- and multiple-disciplinary open discussions.
          We sincerely hope this forum will serve as an ideal and splendid stage for you
          all to enjoy the wonderland of neurosurgery.</span></p><p><span style="font-size: 14px;">Gladly and honorably, we are hosting 10th International Meningioma Society
          and Cerebral Venous System Meeting at the same time partially in combination
          with our BIFNS. This meeting will be more focused on the meningioma and its
          related disciplines. Preceded to this event, there will be two educational
          workshops supported and organized by the World Federation of Neurosurgical
          Societies(WFNS) with a galaxy of masters in this field. Continuing education
          like anatomy classes will also be additional bonus during this event. For those
          who are interested and keen to learn more about this topic, this will definitely
          be a great opportunity.</span></p><p><span style="font-size: 14px;">Autumn in Beijing is an amazing season, here you can climb the Great Wall
          without sweating, view the Red Leaves in Xiangshan, jog along the Summer Palace,
          or taste some beer with friends in the pubs along Houhai. Surely hundreds of
          delicious Chinese food await you. Beijing is a place not only for meeting old
          friends, but making new ones. We sincerely hope you can join us and look much
          forward to seeing you all.</span>
          </p><p>
          <span style="font-size: 14px;">Sincerely yours</span>
          </p><p><span style="font-size: 14px;">Co-Presidents of BIFNS</span>
          </p>
          <div style="height: 163px;">
            <p style="padding-bottom:0!important;">
            <img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344023596024417540178.JPG" title="张力伟_1.JPG" alt="张力伟_1.JPG" style="float: left;">
            </p>
            <p>
            <span style="font-size: 14px;"> Liwei Zhang, MD PhD</span></p><p><span style="font-size: 14px;"> Vice President of Beijing Tiantan Hospital</span>
            </p>
            <p>
            <span style="font-size: 14px;"> Professor</span></p><p><span style="font-size: 14px;"> </span>
            <img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344767865194177498012.jpg" title="236362344060021407828859421.jpg" alt="236362344060021407828859421.jpg"></p>
            <p>
          </div>


          <div style="height: 163px;">
          <span style="font-size: 14px;"> </span>
          <img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344176269556847431651.JPG" title="张俊廷_1.JPG" alt="张俊廷_1.JPG" style="float: left;">
          <span style="font-size: 14px;">Junting Zhang, MD<br></span>
          </p><p><span style="font-size: 14px;"> Chair of Department of Neurosurgery</span></p><p><span style="font-size: 14px;">
          Beijing Tiantan Hospital</span></p><p><span style="font-size: 14px;">  </span>
          <img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344075027766143681080.jpg" title="张俊廷主任英文签名_1.jpg" alt="张俊廷主任英文签名_1.jpg"></p><p>
          </div>

          <img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344081947261914791747.jpg" style="float:left;" title="张亚卓_1.jpg" alt="张亚卓_1.jpg">

          <span style="font-size: 14px;">Yazhuo Zhang, MD PhD<br></span></p><p><span style="font-size: 14px;">
          Director, Beijing Neurosurgical Institute</span></p><p><span style="font-size: 14px;"> Professor</span></p><p>
           <img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/02/236362344093884944715200299.JPG" title="张亚卓英文_1.JPG" alt="张亚卓英文_1.JPG"></p>
            </div>
            </div>
           `,
                    `
                   <div class="article_con">
 <h1 class="title3" style="text-align: center;"> <font color="">Meeting of International Meningioma society</font></h1>
 <div style="display:none">浏览次数：

<span id="ajax_div__GetArticleViewCount_0_5794_0_4661">
272</span></div>
 <div class="article_cont" id="zoom">
 <p><span style="font-size: 14px;">Dear Colleagues, Fellows and Friends</span></p><p><span style="font-size: 14px;">As Presidents of Meningioma Congress 2017 ofInternational Meningioma Society (IMS), it is our great pleasure and honor to invite you for this event on November 5th, 2017 in Beijing, People’s Republic of China.Being one of the most important organizations in neurosurgery, IMS was firstlyestablished in September 2006 at the Mt. Fuji Meeting, Japan hosted by Dr. Takeshi Kawase, aiming to advancing the art ofthe clinical care and research inintracranial meningiomas. Previous meetings have been hosted successfully worldwide and we are very glad to see it is coming to China soon.</span></p><p><span style="font-size: 14px;">Meningioma is the most common primary intracranial tumor. Although we have achieved a great amount of knowledge after decades of clinic and basic research, it never stops puzzling and surprisingus how complex and difficult this disease can be. Collaboration among neurosurgeons, radiation oncologists, biomedical scientists and many other professionals has become a mainstreamto fight against it for those suffering patients.</span></p><p><span style="font-size: 14px;">Neurosurgery in China has progressed dramatically during the past five decades. Standing on those pioneers’ shoulders and being inspired by the global mainstream of the meningioma treatment, nowadays our Chineseneurosurgeonsare not only justsatisfied with achieving the total gross resection but also dedicated to protecting the patient’s quality of life postoperatively. Numerous research studies, both clinically and scientifically,have been carried out for further exploringthis type of neoplasm. Our fellow surgeons arekeen to learn the ever-advancing knowledge andhope to exchange their clinical knowledge and experiences with other professionalcolleagues worldwide. We arevery glad to see a number of honorable experts in this field from different countries will join us, too.</span></p><p><span style="font-size: 14px;">“Communication, Innovation and Development” are the theme of this coming event in Beijing.We expect itwill be an ideal stage for better communication between Chinese neurosurgeons and international fellows, be a great place to spark brilliant ideas and strategies for better understanding and treating this disease.</span></p><p style="line-height:115%"><span style="color: rgb(38, 38, 38); font-size: 14px;"></span></p><p><span style="font-size: 14px;">We are looking forward to seeing you all, and sincerely hope you have a great time in Beijing.</span></p><p><span style="font-size: 14px;">Best regards,<br></span></p><p><span style="font-size: 14px;">Your sincerely,</span></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><span style="font-size: 14px;">Co-Presidents of IMS</span></p><p style="margin-top: 0px; margin-bottom: 0px; padding-top: 0px; padding-right: 0px; padding-left: 0px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; padding-bottom: 0px !important; background-color: rgb(255, 255, 255);"><img src="http://www.bjtth.org/Sites/Uploaded/Image/2017/02/236362344023596024417540178.JPG" title="张力伟_1.JPG" alt="张力伟_1.JPG" style="margin: 0px; padding: 0px; border: none; vertical-align: middle; float: left;"></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><span style="font-size: 14px;"> Liwei Zhang, MD PhD</span></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><span style="font-size: 14px;"> Vice President of Beijing Tiantan Hospital</span></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><span style="font-size: 14px;"> Professor</span></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><img src="http://www.bjtth.org/Sites/Uploaded/Image/2017/02/236362344767865194177498012.jpg" title="236362344060021407828859421.jpg" alt="236362344060021407828859421.jpg" style="margin: 0px; padding: 0px; border: none; vertical-align: middle;"></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><img src="http://www.bjtth.org/Sites/Uploaded/Image/2017/02/236362344176269556847431651.JPG" title="张俊廷_1.JPG" alt="张俊廷_1.JPG" style="margin: 0px; padding: 0px; border: none; vertical-align: middle; float: left;"><span style="font-size: 14px;">Junting Zhang, MD<br></span></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><span style="font-size: 14px;">Chair of Department of Neurosurgery</span></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><span style="font-size: 14px;">Beijing Tiantan Hospital</span></p><p style="margin-top: 0px; margin-bottom: 0px; padding: 0px 0px 10px; border: none; line-height: 28px; color: rgb(77, 77, 77); font-family: Arial, 微软雅黑; white-space: normal; background-color: rgb(255, 255, 255);"><img src="http://www.bjtth.org/Sites/Uploaded/Image/2017/02/236362344075027766143681080.jpg" title="张俊廷主任英文签名_1.jpg" alt="张俊廷主任英文签名_1.jpg" style="margin: 0px; padding: 0px; border: none; vertical-align: middle;"></p><p style="text-align: left;"><br></p>
  </div>
  </div>



                    `,

                    `


                    <div class="Column_R">
 <div class="article_con">
 <h1 class="title3"> <font color="">Meningioma Society Announcement</font></h1>
 <div style="display:none">浏览次数：

<span id="ajax_div__GetArticleViewCount_0_6038_0_2551">
102</span></div>
 <div class="article_cont" id="zoom">
 <p><span style="font-size: 14px;">Dear Colleagues and Friends:</span></p><p><span style="font-size: 14px;">Please join me for the 11th Congress of International Meningioma Society and
Cerebral Venous System to be held November 4 through November 5, 2017, in
Beijing, China.</span></p><p><span style="font-size: 14px;">The International Meningioma Society was formed in 2008 and aims at advancing
the art of science of the field of clinical care and research in meningiomas and
thereby promotes the best possible care for patients suffering from meningiomas.
This meeting endeavors to provide the latest updates and recent advances in the
treatment of meningioma and our understanding of the cerebral venous system.</span></p><p><span style="font-size: 14px;">We look forward to seeing you in Beijing. For additional information, please
check www.meningiomasociety.org.</span></p><p style="padding-bottom: 0px !important;"><img src="http://bifns.bjtth.org/Sites/Uploaded/Image/2017/03/266362616294715193398419503.png" title="QQ截图20170326221549.png" alt="QQ截图20170326221549.png"></p><p style="padding-bottom: 0px !important;"><br></p>
  </div>
  </div>
 </div>


                    `,
  `<div class="article_con">
 <h2 class="common_tit">General Inforamtion <i></i>
 </h2>

 <h1 class="title3"> <font color="">BIFNS Introduction</font></h1>
 <div style="display:none">浏览次数：

<span id="ajax_div__GetArticleViewCount_0_6006_0_5534">
43</span></div>
 <div class="article_cont" id="zoom">
 <p>The Department of Neurosurgery of Beijing TianTan Hospital was founded and expanded by our beloved Dr. Wang Zhongcheng, a former academician of Chinese Academy of Engineering, aiming to develop the practice of neurosurgery in China and saving those who suffered from neurosurgical diseases. Thanks to Dr. Wang and those pioneering colleagues, Neurosurgery department of Beijing TianTan Hospital has been ranked as No.1 in neurosurgery in China for years. The annul number of neurosurgical operations is over 10,000 for the last five years, predominately in brain cases and many of which were difficult and complex cases from all over China. </p><p>Supported by both state and local government, New Beijing Tiantan Hospital was proposed and started construction in HuaXiang (“County of flower”) south of Beijing, seating 1650 inpatient beds equipped with advanced facilities. The opening of our new hospital will be in October of 2017, providing a better healthcare care service and clinical-scientific research.To celebrate this historical moment, 1st Beijing Tiantan International Forum of Neurosurgery (BIFNS) is scheduled to be held from November 2-5, 2017, aiming to demonstrate the current neurosurgical progress and outline the future of this specialty. Theforum will consist of several events, including congress and pre-congress training courses and international meeting of meningioma. Thetopics will cover the sub-specialties of neurosurgery and its related subjects. </p><p>For more information about registration, topics and introduction of speakers, please visit <a href="http://bifns.bjtth.org" target="_self">bifns.bjtth.org</a></p><p><br></p>
  </div>
  </div>`,

  `<div class="article_cont" id="zoom">
 <p>The Department of Neurosurgery of Beijing TianTan Hospital was founded and expanded by our beloved Dr. Wang Zhongcheng, a former academician of Chinese Academy of Engineering, aiming to develop the practice of neurosurgery in China and saving those who suffered from neurosurgical diseases. Thanks to Dr. Wang and those pioneering colleagues, Neurosurgery department of Beijing TianTan Hospital has been ranked as No.1 in neurosurgery in China for years. The annul number of neurosurgical operations is over 10,000 for the last five years, predominately in brain cases and many of which were difficult and complex cases from all over China. </p><p>Supported by both state and local government, New Beijing Tiantan Hospital was proposed and started construction in HuaXiang (“County of flower”) south of Beijing, seating 1650 inpatient beds equipped with advanced facilities. The opening of our new hospital will be in October of 2017, providing a better healthcare care service and clinical-scientific research.To celebrate this historical moment, 1st Beijing Tiantan International Forum of Neurosurgery (BIFNS) is scheduled to be held from November 2-5, 2017, aiming to demonstrate the current neurosurgical progress and outline the future of this specialty. Theforum will consist of several events, including congress and pre-congress training courses and international meeting of meningioma. Thetopics will cover the sub-specialties of neurosurgery and its related subjects. </p><p>For more information about registration, topics and introduction of speakers, please visit <a href="http://bifns.bjtth.org" target="_self">bifns.bjtth.org</a></p><p><br></p>
  </div>`,`<div class="article_cont" id="zoom">
 <p style="white-space: normal; line-height: 18.4px;"><strong><span style="font-family: Baskerville;">International meningioma society (IMS)</span></strong></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">Officially founded in September 2006 at the Mr.Fuji Meeting, which was hosted by Prof. Takeshi Kawase, the International Meningioma Society(IMS) has brought international neurosurgeons, radiation oncologists, basic research scientists and epidemiologists together to fight this puzzling and sophisticated disease. The mission of IMS is to achieve “the advancement of the understanding of the biology and treatment of meningiomas and to improve the lives of patients afflicted”.</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">IMS is a non-profit unincorporated public benefit society. The current president of IMS is Prof. Prof. Kenji Ohata, vice-president is Prof. Volker Seifert and Prof. Michael McDermott serves as treasure secretary. The detailed information about IMS can be found at </span><a href="http://www.meningiomasociety.org/"><span style="font-family: Baskerville;">www.meningiomasociety.org</span></a><span style="font-family: Baskerville;">.</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">The regular meeting of IMS has attracted numerous academicians each time, making it a great academic event for those who are working in this area and interested in this disease. Since its first symposium back in 1992, IMS has organized over 10 events insofar and has contributed in advancing the understanding and treatment of meningioma. In the last meeting in June, 2016 in Osaka, Japan, the committee announced the 2017 IMS meningioma meeting is to be held in Beijing, host by Dr.Liwei Zhang and Dr. Junting Zhang, bothfrom Beijing Tiantan Hospital of Capital Medical University, China.</span></p><p style="white-space: normal; line-height: 18.4px;"><strong><span style="line-height: 18.4px; font-family: Baskerville;">Subjects includes</span><span style="line-height: 18.4px; font-family: 华文仿宋;">：</span></strong></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">1.Anterior cranial fossa and sellar region meningiomas</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">2.middle cranial fossa and cavernous sinus meningiomas</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">3.posterior cranial fossa meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">4.Brain function and meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">5.Venous sinus related meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">6.Cranial nerves and meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">7.Venous reconstruction and management of arterial encasement in meningiomas</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">8.New technique in management of meningiomas</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">9.Endoscopic management of meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">10.Pediatric meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;"></span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">11.Pregnancy and meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">12.Incidental finding meningioma and natural history</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">13.Malignant meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">14.Radiotherapy for meningioma</span></p><p style="white-space: normal; line-height: 18.4px;"><span style="font-family: Baskerville;">15.Basic research advances in meningioma</span></p><div><span style="font-family: Baskerville;"><br></span></div><p style="white-space: normal; line-height: 18.4px;"><br></p>
  </div>`,`<div class="article_con">
 <h2 class="common_tit">Agenda <i></i>
 </h2>

 <h1 class="title3"> <font color="">Schedule</font></h1>
 <div style="display:none">浏览次数：

<span id="ajax_div__GetArticleViewCount_0_5787_0_1790">
168</span></div>
 <div class="article_cont" id="zoom">
 <p>　　会议名称：北京天坛国际<a target="_blank" href="/Departments/Main?siteId=21003" class="keyword_Default ">神经外科</a>论坛 Beijing Tiantan International Forum of neurosurgery
(BIFNS)</p><p>　　1. 11月4-5号：大会Congress of Beijing Tiantan International Forum of
neurosurgery 11.4-5</p><p>　　2. 11月5号：世界脑膜瘤大会 IMS Congress of international society of meningioma and
venous system 11.5</p><p>　　3. 会前会：11月2-3日</p><p>　　3.1 世界<a target="_blank" href="/Departments/Main?siteId=21003" class="keyword_Default ">神经外科</a>联盟WFNS-EC继续教育委员会培训班 (Bertalanffy H.)</p><p>　　3.2 世界<a target="_blank" href="/Departments/Main?siteId=21003" class="keyword_Default ">神经外科</a>联盟WFNS-AC解剖委员会培训班(Benes V.)</p><p style="text-align: center;">　　日程安排</p><p></p><table border="1" align="center" cellpadding="0" cellspacing="0"><tbody><tr class="firstRow"><td width="85" valign="top"><p>Date</p></td><td width="88" valign="top" style="word-break: break-all;"><p style="text-align:center;">Nov.2</p></td><td width="88" valign="top" style="word-break: break-all;"><p style="text-align:center;">Nov.3</p></td><td width="90" valign="top" style="word-break: break-all;"><p style="text-align:center;">Nov.4</p></td><td width="90" valign="top" style="word-break: break-all;"><p style="text-align:center;">Nov.5</p></td></tr><tr><td width="85" valign="top"><p> </p></td><td width="88" valign="top"><p style="text-align:center;">Thu</p></td><td width="88" valign="top"><p style="text-align:center;">Fri</p></td><td width="90" valign="top"><p style="text-align:center;">Sat</p></td><td width="90" valign="top"><p style="text-align:center;">Sun</p></td></tr><tr><td width="85" valign="top"><p> </p></td><td width="176" valign="top" colspan="2"><p style="text-align:center;">Pre-Congress course</p></td><td width="181" valign="top" colspan="2"><p style="text-align:center;">Congress</p></td></tr><tr><td width="85" valign="top"><p> </p></td><td width="88" valign="top"><p style="text-align:center;"> </p></td><td width="88" valign="top"><p style="text-align:center;"> </p></td><td width="90" valign="top" bgcolor="#efe3e3"><p style="text-align:center;">Congress BINS</p></td><td width="90" valign="top" bgcolor="#efe3e3"><p style="text-align:center;">Congress BINS</p></td></tr><tr><td width="85" valign="top"><p> </p></td><td width="88" valign="top"><p style="text-align:center;"> </p></td><td width="88" valign="top"><p style="text-align:center;"> </p></td><td width="90" valign="top"><p style="text-align:center;"> </p></td><td width="90" valign="top" bgcolor="#ffe599"><p style="text-align:center;">IMS</p></td></tr><tr><td width="85" valign="top"><p> </p></td><td width="88" valign="top" bgcolor="#ffff00"><p style="text-align:center;">WFNS-EC</p></td><td width="88" valign="top" bgcolor="#ffff00"><p style="text-align:center;">WFNS-EC</p></td><td width="90" valign="top"><p style="text-align:center;"> </p></td><td width="90" valign="top"><p style="text-align:center;"> </p></td></tr><tr><td width="85" valign="top"><p> </p></td><td width="88" valign="top" bgcolor="#bdd6ee"><p style="text-align:center;">WFNS-AC</p></td><td width="88" valign="top" bgcolor="#bdd6ee"><p style="text-align:center;">WFNS-AC</p></td><td width="90" valign="top"><p style="text-align:center;"> </p></td><td width="90" valign="top"><p style="text-align:center;"><br></p></td></tr></tbody></table><p><br></p><p></p>
  </div>
  </div>`



                ]
            }
        },
        computed: {
            list() {
                return this.lists[this.id];
            }
        },
        props: {},
        methods: {
            tab(index, item) {
                this.activeTab = index;
                //        点击注册
                if (item.reg !== undefined) {
                    //            如果已经登录了就直接跳转到报名信息页
                    let user = localStorage.getItem('user') !== null && localStorage.getItem('user') !== '';
                    if (user) {
                        this.$router.push('/sign/add');
                        return;
                    }
                    this.flag = true;
                }
            },
        },
    mounted() {
        this.id = this.$route.params.id;
    }
}
</script>
<style scoped>
.contain {
    color: #000000;
    width: 1200px;
    font-size: 16px;
    border: 1px solid #eeeeee;
    margin: 130px auto 30px;
    padding: 20px;
}

p {
    text-indent: 2rem;
}

.active-laguage {
    color: #5cadff;
}

.exitActive {
    color: #00c261;
}

ul,
li {
    padding: 0;
    margin: 0;
    list-style: none;
}

.left {
    float: left;
}

.right {
    float: right;
}

.clear:after {
    display: block;
    content: "";
    clear: both;
}

.container {
    width: 100%;
    background-color: #000;
}

header {
    width: 1200px;
    margin: auto;
    height: 39px;
    color: #fff;
    font-size: 18px;
    /*display: flex;*/
    /*justify-content: flex-end;*/
}

header div {
    width: 100px;
    line-height: 39px;
    position: relative;
    float: right;
    display: inline-block;
}

.language-line {
    height: 20px;
    border-right: 1px solid #fff;
    position: absolute;
    right: 17px;
    top: 10px;
}

.banner {
    width: 100%;
    height: 400px;
    margin: 0 auto;
    text-align: center;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
}

.banner .swiper-container,
.banner .swiper-container .swiper {
    width: 100%;
    height: 100%;
}

.swiper-img {
    width: 100%;
    height: 100%;
}


/*导航*/

.nav {
  width: 1200px;
  /* height: 80px; */
  bottom: 10px;
  margin: -82px auto 0;
  text-align: left;
  font-size: 14px;
}

.nav-box {
    position: relative;
    z-index: 10;
}
.nav-box li{
  position: relative;
}

.nav-box.fix {
    position: fixed;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
}

.nav li {
    width: 168px;
    padding: 8px 0;
    text-align: center;
    background-color: #ffffff;
    cursor: pointer;
    color: #000000;
    margin-right: 2px;
    float: left;
    line-height: 53px;
}

.en-language {
    font-size: 14px;
    color: #a3a3a3;
}

.nav li i {
    color: #4C4E82;
    font-size: 27px;
    vertical-align: text-bottom;
}

.nav .active-tab {
    background-color: #F39800;
    color: #ffffff;
}

.nav .active-tab .en-language {
    color: #ffffff;
}

.nav .active-tab i {
    color: #FFFFFF;
}

.nav-text {
    /*margin-left: 12px;*/
}

.container-box {
    width: 1200px;
    margin: 0 auto;
}

.item {
    margin-top: 50px;
}

.new {
    color: red;
    font-size: 14px;
    margin-left: 5px;
}

.teacher-des {}

.teacher-video {
    width: 794px;
    height: 470px;
    background-color: #000000;
    float: left;
    margin-right: 20px;
}

.teacher-font {
    width: 384px;
    float: left;
}

.teacher-font h3 {
    font-size: 24px;
    color: #000000;
    font-weight: 400;
}

.teacher-title {
    font-size: 14px;
    color: #e6e5e5;
}

.teacher-head {
    display: flex;
    border-bottom: 1px solid #E6E5E5;
    margin-bottom: 22px;
    padding-bottom: 22px;
}

.teacher-head img {
    width: 152px;
    height: 122px;
    margin-right: 24px;
}

.teacher-font-content {
    font-size: 22px;
    color: #000000;
    line-height: 1.5;
    word-break: break-all;
}

.author-des {
    width: 1200px;
    height: 548px;
    position: relative;
    background: url("http://www.medicalcircle.cn/lib/tpl/tt.png") no-repeat center center;
    overflow: hidden;
}

.author-des .swiper-container {
    height: 100%;
}

.author-des .swiper-wraper {
    height: 100%;
}

.author-des .swiper-slide {
    position: relative;
    height: 100%;
}

.author-des-content {
    /*padding: 25px 48px 25px 48px;*/
    background-color: #2b2d62;
    bottom: 0;
    position: absolute;
    width: 100%;
    box-sizing: border-box;
    color: #FFFFFF;
    /*display: flex;*/
    z-index: 5;
    padding: 30px 48px 29px 48px;
}

.author-des-content .author-des-icon {
    float: left;
}

.author-des-content .author-des-title {
    width: 1033px;
}

.author-des-icon {
    margin-right: 24px;
    margin-top: 6px;
    float: left;
}

.author-des-title {
    float: left;
}

.author-des-title h3 {
    font-size: 24px;
    font-weight: 500;
}

.author-des-title div {
    font-size: 14px;
}

.author-des-con {
    transition: all ease-in .2s;
    top: 100%;
    bottom: -100%;
    overflow: hidden;
    width: 100%;
    height: 100%;
    position: absolute;
}

.author-des-con-box {
    width: 600px;
    font-size: 16px;
    position: absolute;
    left: 50%;
    top: 30%;
    transform: translateX(-50%)
}

.author-des-con.active {
    bottom: 107px;
    top: 0;
    right: 0;
    color: #FFFFFF;
    left: 0;
    padding: 10px;
    width: 100%;
    box-sizing: border-box;
    background-color: rgba(0, 0, 0, .3);
}

.indent {
    text-indent: 2rem;
}


/*最新动态*/

.top-bar {
    padding: 25px 48px 25px 48px;
    background-color: #f4f4f7;
    /*display: flex;*/
}

.dtai {}

.dtai-download-box {
    color: #ffffff;
    float: left;
}

.dtai-news-box {
    width: 897px;
    margin-right: 5px;
    float: left;
}

.dtai-news-content {
    padding: 44px 0 0 38px;
    font-size: 20px;
    line-height: 2;
    color: #000000;
}

.dtai-download-content {
    background-color: #2b2d62;
    margin-top: 8px;
    font-size: 18px;
    width: 298px;
    padding: 30px;
    line-height: 2;
}

.dtai-download-content li {
    margin-top: 30px;
    width: 240px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.list-swiper-box {}

.list-swiper-box .swiper-slide img {
    width: 100%;
    height: 257px;
    border: 1px solid #000000;
}

.list-swiper-title-box {
    text-align: center;
    border: 1px solid #b0b3ae;
    padding: 0 11px;
    height: 257px;
    margin-top: -5px;
    border-top: 0;
}

.list-swiper-title,
.list-swiper-title2 {
    font-size: 34px;
    color: #1533B7;
    font-weight: 500;
}

.list-swiper-title2 {
    font-size: 16px;
    color: #000000;
    /* font-weight: 500; */
    /*text-align: left;*/
    /*text-indent: 2rem;*/
}


/*公司底部信息*/

.brand-box {
    background-color: #141651;
    padding: 27px 73px;
    color: #ffffff;
}

.brand-content {
    width: 1200px;
    margin: 0 auto;
}

.brand-content-title {
    font-size: 24px;
}

.brand-content-title2 {
    font-size: 14px;
    color: #aaaaaa;
    margin-bottom: 30px;
}

.brand-box ul {
    line-height: 2;
    font-size: 18px;
    margin-top: 5px;
}

.brand-content-box ul {
    float: left;
    /*display: flex;*/
    /*justify-content: space-between;*/
}

.address {
    margin-right: 12px;
}

.erwm {
    width: 148px;
    height: 148px;
    background-color: #FFFFFF;
    float: right;
}

.download-btn {
    cursor: pointer;
}

.fangan1 {
    float: left;
    width: 33.33%;
    padding: 30px;
    box-sizing: border-box;
}

.fangan1 > img {
    width: 100%;
    height: 246px;
}
#_nav .nav-child {
  position: absolute;
  left: 0;
  top: 100%;
  background-color: #FFFFFF;
  font-size: 14px;
  line-height: 2em;
  /*padding-bottom: 20px;*/
  z-index: 100;
  width: 100%;
}

.nav-child-item {
  color: #000;
}

.nav-child-item:hover {
  color: #ffffff;
  background-color: #F39800;
}
</style>



// WEBPACK FOOTER //
// temp_view.vue?4777cf2b